export default {"src":"/_next/static/media/papaya.0cf1692e.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};